import { render } from "./AddTopic.vue?vue&type=template&id=41236275"
import script from "./AddTopic.vue?vue&type=script&lang=js"
export * from "./AddTopic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__